import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { v4 as uuidv4 } from "uuid";
import applcation from "../../assets/application.png";
import feedback from "../../assets/feedback.gif";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
const baseBtn =
  "absolute top-1/2 -translate-y-1/2 z-10 w-11 h-11 md:w-12 md:h-12 rounded-full flex items-center justify-center transition-all duration-300";

export const CustomLeftArrow = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        ${baseBtn} left-2
     bg-black/20 text-black/70

        hover:bg-gradient-to-r hover:from-[#0D3559] hover:to-blue-500
        hover:text-white
        hover:scale-110

        animate-[float_2.5s_ease-in-out_infinite]
        hover:shadow-[0_0_20px_rgba(13,53,89,0.6)]
      `}
    >
      <FaChevronLeft size={14} />
    </button>
  );
};

export const CustomRightArrow = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`
        ${baseBtn} right-2
       bg-black/20 text-black/70

        hover:bg-gradient-to-r hover:from-blue-500 hover:to-[#0D3559]
        hover:text-white
        hover:scale-110

        animate-[float_2.5s_ease-in-out_infinite]
        hover:shadow-[0_0_20px_rgba(13,53,89,0.6)]
      `}
    >
      <FaChevronRight size={14} />
    </button>
  );
};
const Testimonials = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 2, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 2, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  let featureList = [
    // {
    //   id: uuidv4(),
    //   title: " Bramhanand Patil",
    //   company: "SaiSantha",
    //   image: webDesign,
    //   description:
    //     "Working with Flint Infotech was a game-changer for us. Their dynamic web app solution significantly boosted our online presence, and the team's dedication to perfection was truly commendable.",
    // },
    // {
    //   id: uuidv4(),
    //   title: " Narsu Patil",
    //   company:
    //     "E.B.GADKARI HOMOEOPATHIC MEDICAL COLLEGE & HOSPITAL, GADHINGLAJ",
    //   image: webDesign,
    //   description:
    //     "Flint Infotech delivered beyond our expectations. Their e-commerce web app not only streamlined our sales but also provided an unparalleled shopping experience for our customers. Highly recommended!",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Aishwarya Patel",
    //   company: "Tech Innovators Pvt. Ltd.",
    //   image: webDesign,
    //   description:
    //     "Choosing Flint Infotech for our static web app needs was the right decision. Their elegant designs and user-friendly interface have transformed our online image, leaving a lasting impression on our clients.",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Rajesh Kumar",
    //   company: "Global Solutions Enterprises",
    //   image: coding,
    //   description:
    //     "Flint Infotech's business web app revolutionized our internal processes. The customized solution enhanced our efficiency, and their commitment to our project was exemplary.",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Priya Sharma",
    //   company: "Eminent Financial Consultants",
    //   image: applcation,
    //   description:
    //     "Dynamic web apps by Flint Infotech brought our ideas to life. The real-time updates and interactive features have significantly boosted user engagement, making our platform more vibrant and appealing.",
    // },
    // {
    //   id: uuidv4(),
    //   title: "Anand Gupta",
    //   company: "Stellar Pharmaceuticals Inc.",
    //   image: applcation,
    //   description:
    //     "Kudos to Flint Infotech for their exceptional cloud development expertise. Their solutions have elevated our digital infrastructure, providing scalability and security that align perfectly with our business goals.",
    // },
    {
      id: uuidv4(),
      title: "Mr. Rafique Batliwala",
      company: "Al-Nuaim Group",
      image: applcation,
      description:
        "I would personally like to endorse the quality, expertise and professionalism of all the people that work at Flint Infotech. I can highly recommend this company which has at all times in the development cycle of our project expectation has met.",
    },
     { 
      id:uuidv4(),
      title:"Mr. Amarjeet Tiwari",
      company:"Manipal Technologies Limited",
      image:applcation,
      description:
      "Flint Infotech has been providing Mobile and Web application development services has delivered as per requirements and better than the expectations of Enterprise Fraud Risk Management Solution. We truly enjoy working with Flint's committed team."

    },
    {
      id: uuidv4(),
      title: "Ms. Geeta Maheshwari",
      company: "Efficacious India Limited",
      image: applcation,
      description:
        "Flint Infotech has been providing Mobile and Web application development services and server managed services has delivered as per requirements and better than the expectations of E-SMART School Application. We truly enjoy working with Flint's committed team.",
    },

    {
      id: uuidv4(),
      title: "Dr. Ankita Singh",
      company: "MooRopan",
      image: applcation,
      description:
        "I truly appreciate the expertise and dedication of the Flint Infotech team. They delivered the MooRopan website focused on cow healthcare product sales and services, meeting all our expectations. The team was professional, responsive, and detail-oriented. We're very satisfied with the result and I highly recommend Flint Infotech for any web development needs.",
    },
    {
      id: uuidv4(),
      title: "Dr. R Bala",
      company: "Spandan Center",
      image: applcation,
      description:
        "Flint Infotech did an excellent job building the Spandan Center Hospital website. They understood our needs, delivered a clean and user-friendly design, and were highly professional and responsive throughout. We’re very happy with the result and highly recommend their services.",
    },
    {
      id: uuidv4(),
      title: "Mr. Vikrant Patil",
      company: "(आमदार-विधान परिषद महाराष्ट्र)",
      image: applcation,
      description:
        "When we first contacted Flint Infotech, we needed expert advice on the creation of the voter data analytical solution to achieve for establish connection with voter and build a messege system for communication . After a series of meeting , flint Infotech,consultants analyzed our workloads, documentation, and the existing infrastructure and provided us with a clear project roadmap.",
    },
    {
      id: uuidv4(),
      title: "Mr. Shrikant Reddy",
      company: "S.V Industries",
      image: applcation,
      description:
        "Flint Infotech has provided reliable and efficient Transport Management solutions, exceeding our expectations. Their team ensured smooth development and deployment, making operations more streamlined and responsive. It’s been a pleasure working with such a committed partner.",
    },

    {
      id: uuidv4(),
      title: "Mr. Pratik Chachad",
      company: "श्री शिवसह्याद्री संस्था महाराष्ट्र",
      image: applcation,
      description:
        "Very patient and polite staff. Ready to rework on any small thing till you get what you desire. It was a nice experience to work with them during our website development. Best wishes from my side",
    },{
      id:uuidv4(),
      title:"Mr. Sagar Mhatre",
      company:"Sagar Transport Compony",
      image:applcation,
      description:
      "Flint Infotech provides smart transport software solutions to simplify fleet management, vehicle tracking, trip planning, and transportation operations. Our technology helps businesses improve efficiency, reduce costs, and manage their transport operations seamlessly."
    },
    {
      id: uuidv4(),
      title: "Mr. Bramhanand Patil",
      company: "Sais Sanstha &  JNPV School ",
      image: applcation,
      description:
        "The team showed a strong understanding of our needs and goals from the outset. They took the time to listen to our requirements and thus providing us the best possible tailored solution.",
    },
    {
  id: uuidv4(),
  title: "Mr. Narasu Patil",
  company: (
    <>
      E. B. GADKARI HOMOEOPATHIC &
      <br />
      NARASU PATIL COLLEGE OF<br/> PHYSIOTHERAPY
    </>
  ),
  image: applcation,
  description:
    "The design of the website effectively reflects the professional and authoritative image of our institute. We appreciate efforts, collaboration, professionalism, and support the team has shown to us.",
},
  ];

  return (
    <div className="mt-10" id="reviews">
      <h2 className="text-4xl font-bold text-center text-[#0D3559] mb-12 relative">
        What our customers say
        <span className="block w-24 h-1 bg-[#0d3559] mx-auto mt-3 rounded-full"></span>
      </h2>
      <div className="px-2 sm:px-4 mt-10 rounded-xl mx-2 sm:mx-20">
        <Carousel
          responsive={responsive}
          infinite={true}
          className="py-4"
          itemClass="px-1 sm:px-4"
          partialVisible={false}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
        >
          {featureList.map((item) => (
            <div
              key={item.id}
              className="flex flex-col justify-between w-full rounded-xl shadow-md p-4 h-full bg-gradient-to-b from-[#7bb6ea] to-blue-900 border border-slate-300"
            >
              <div className="font-notosans p-3 text-[15px]">
                {item.description}
              </div>
              {/* <div className="w-16 overflow-hidden inline-block">
                <div className=" h-5 w-5 mx-5 bg-gray-200 -rotate-45 transform origin-top-left"></div>
              </div> */}
              <div className=" text-black font-bold font-notosans flex items-center gap-7">
                <div>
                  <img src={feedback} className="w-16" alt="" />
                </div>
                <div>
                  <p>{item.title}</p>
                  <div className="group cursor-pointer relative inline-block">
                    <p className="overflow-hidden truncate w-60 text-sm">
                      {item.company}
                    </p>
                    <div className="opacity-0 w-full bg-black text-white text-center text-xs rounded-lg py-2 absolute z-10 group-hover:opacity-100 bottom-full -left-1/2 ml-14 px-3 pointer-events-none">
                      {item.company}
                      <svg
                        className="absolute text-black h-2 w-full left-0 top-full"
                        x="0px"
                        y="0px"
                        viewBox="0 0 255 255"
                      >
                        <polygon
                          className="fill-current"
                          points="0,0 127.5,127.5 255,0"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Testimonials;
